<template>
    <section class="app-spa">
        <section class="app-spa__box">
            <section class="app-spa__box__logo">
                <img :src="$appConfig.logo.path" :alt="$appConfig.logo.alt" />
            </section>
            <section class="app-spa__box__form">
                <h1 class="app-spa__box__form__header">{{$t('com.file.app-locked.app-blocked')}}</h1>
                <p class="app-spa__box__form__text">
                    {{$t('com.file.app-locked.app-blocked-pin-info')}}
                </p>
                <section class="app-spa__box__form__fallback-error" v-if="isError">
                    <img src="@/assets/icons/components/exit-btn.svg" class="app-spa__box__form__fallback-error__icon" :alt="$t('com.file.app-locked.error-icon-text')" />
                    <span class="app-spa__box__form__fallback-error__text">
                        {{$t('com.file.app-locked.check-data')}}
                    </span>
                </section>
                <section class="app-spa__box__form__row">
                    <label for="user-pin" class="app-spa__box__form__label">{{$t('com.file.app-locked.pin')}}</label>
                    <input type="password"
                           name="user-pin"
                           id="user-pin"
                           class="app-spa__box__form__input"
                           v-model="pin"
                           :placeholder="$t('com.file.app-locked.pin-placeholder')"
                           autocomplete="off"
                           @keyup.enter="unlockApplication" />
                </section>
                <button type="submit"
                        class="app-spa__box__form__btn"
                        @click="unlockApplication">
                    {{$t('com.file.app-locked.unblock-app')}}
                </button>
                <button type="button"
                        class="app-spa__box__form__btn"
                        @click="logoutUser">
                    {{$t('com.file.app-locked.logout')}}
                </button>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import UserService from "../../services/user.service"
    import { broadcastChannelService } from "../../services/broadcast.channel.service";
    export default {
        name: "AppLocked",
        data() {
            return {
                pin: "",
                isError: false,
            }
        },
        methods: {
            async unlockApplication(e) {
                try {
                    e.preventDefault();
                    this.isError = false;
                    this.$store.commit("showLoader");

                    let request = {
                        pin: this.pin
                    };
                    let response = await UserService.unlokcApplication(request);
                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }
                    this.isError = !response.data;
                    if (response.data === true) {
                        UserService.updateLockState(false);
                        return;
                    }
                }
                catch (e) {
                    this.isError = true;
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'sms' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }

            },
            async logoutUser() {
                await UserService.logout();
                broadcastChannelService.notifyLogout();
            }
        }
    }
</script>
<style lang="scss" scoped>
    @use  "~@/assets/scss/esesja-app-spa.scss";
</style>
